import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FiltersDisplayModule, ItemFilterModule } from "@comunicare/comunicare-angular-filters-display";
import { ItemSelectorModule } from "src/app/components/item-selector/item-selector.module";
import { I18nModule } from "src/app/i18n.module";
import { PipesModule } from "../../pipes/pipes.module";
import { BillingPageComponent } from "./components/billing-page/billing-page.component";
import { InvoiceAggregatedTableComponent } from "./components/invoice-aggregated-table/invoice-aggregated-table.component";
import { InvoiceListComponent } from "./components/invoice-list/invoice-list.component";
import { InvoiceNotesDialogComponent } from "./components/invoice-notes-dialog/invoice-notes-dialog.component";
import { InvoiceSummaryComponent } from "./components/invoice-summary/invoice-summary.component";
import { InvoiceTableComponent } from "./components/invoice-table/invoice-table.component";
import { AvailableStatusTransitionsPipe } from "./pipes/available-status-transitions.pipe";
import { BillingFirstPeriodStartPipe } from "./pipes/billing-first-period-start.pipe";
import { BillingLastPeriodEndPipe } from "./pipes/billing-last-period-end.pipe";
import { BillingLastStatusPipe } from "./pipes/billing-last-status.pipe";
import { I18nPeriodUnitKeyPipe } from "./pipes/i18nPeriodUnitKey.pipe";

@NgModule({
  declarations: [
    BillingPageComponent,
    InvoiceListComponent,
    InvoiceTableComponent,
    BillingPageComponent,
    InvoiceSummaryComponent,
    AvailableStatusTransitionsPipe,
    I18nPeriodUnitKeyPipe,
    InvoiceAggregatedTableComponent,
    BillingFirstPeriodStartPipe,
    BillingLastPeriodEndPipe,
    BillingLastStatusPipe,
    InvoiceNotesDialogComponent,
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    I18nModule,
    MatListModule,
    MatChipsModule,
    ItemFilterModule,
    FiltersDisplayModule,
    MatTooltipModule,
    MatCheckboxModule,
    ItemSelectorModule,
    PipesModule,
    MatSelectModule,
    MatMenuModule,
    MatExpansionModule,
    MatDialogModule,
    DragDropModule,
  ],
  exports: [BillingPageComponent, InvoiceListComponent, BillingPageComponent],
})
export class BillingModule {}
